import React, { Component } from 'react'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import store from '../store'
import { getObjValue } from '@hlj/hlj-utils'
import { Auth } from '@common/Auth'
import { PRIVILEGE_NORMAL_ID, PRIVILEGE_STORE_ID } from '@constant'

@Auth({ role: [PRIVILEGE_NORMAL_ID, PRIVILEGE_STORE_ID] })
@observer
export default class extends Component {
  render() {
    const { holes, txtWidth } = store

    let holesLen = 0
    for (let i = 0, len = holes.length; i < len; i++) {
      if (getObjValue(holes[i], 'posters.target_url')) {
        holesLen++
      }
    }

    return (
      <div
        className={styles.toutiao}
        style={{ display: holesLen ? 'block' : 'none' }}
      >
        <img src="http://qnm.hunliji.com/o_1c5ao3qd2rju1ak3d64g6u8727.jpg" />
        <div className={styles.line} />
        <div className={styles.txt}>
          {holes.map((item, index) => (
            <p key={index}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={getObjValue(item, 'posters.target_url')}
              >
                {getObjValue(item, 'posters.title')
                  ? parseInt(txtWidth / 14) >
                    getObjValue(item, 'posters.title').length
                    ? getObjValue(item, 'posters.title')
                    : getObjValue(item, 'posters.title').substring(
                        0,
                        txtWidth / 14
                      ) + '...'
                  : ''}
              </a>
            </p>
          ))}
        </div>
      </div>
    )
  }
}
